import pL from "js-regex-pl";

/* ref: https://github.com/yury-dymov/js-regex-pl/blob/master/src/index.js
 includes support for other languages (e.g. latin, chinese, japanese etc..) */
export const ALL_LANGUAGE_CHARACTERS_REGEX = `${pL}`;
